import React, { useState, useEffect } from 'react'
import { Wrapper } from "./LeadFormSm.styled";
import LeadSubmission from "components/pageSection/LeadForm/LeadSubmission/LeadSubmission";
import SelectLocation from "components/pageSection/LeadForm/SelectLocation/SelectLocation";
import AdditionalInformation from "components/pageSection/LeadForm/AdditionalInformation/AdditionalInformation";
import Final from "components/pageSection/LeadForm/final/Final";
import LOGO from "../../assets/images/img-logo.png";
import LeadFormSteps from 'views/LeadFormSteps/LeadFormSteps';
import { callGetApi } from 'utils/api';

const LeadFormSm = () => {
  const stepsArray = ['hm', 'lo', 'ad', 'ap'];
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    street: "",
    city: "",
    state: "",
    zip: "",
    notes: "",
    utilPic: null,
    appointmentTime: "",
    dateCreated: Date().toString(),
    averageMonthlyBill: "",
    yearlyUsage: "",
    company_id: 9146,
    forceSend: "",
    utility_company: "",
    utility_id: "",
    lat: "",
    lng: "",
    jan: "",
    feb: "",
    mar: "",
    apr: "",
    may: "",
    jun: "",
    jul: "",
    aug: "",
    sep: "",
    oct: "",
    nov: "",
    dec: "",
  });
  useEffect(() => {
    initailFormApi();
  }, []);
  const initailFormApi = () => {
    callGetApi("/leads/form/calender/event", onSuccessForm, onFailForm);
  };

  const onSuccessForm = (data) => {
  };
  const onFailForm = (err) => {
    console.log(err);
  };

  const next = () => {
    if (currentStep < 3) {
      setCurrentStep(currentStep + 1)
    }
  }
  const prev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1)
    }
  }

  return (
    <Wrapper>
      <div className="logo">
        <img src={LOGO} alt="Own Logo" />
      </div>
      <LeadFormSteps label={stepsArray[currentStep]} />

      {stepsArray[currentStep] === 'hm' && (
        <LeadSubmission
          next={next}
          setFormData={setFormData}
          formData={formData}
          isSmall={true}
        />
      )}
      {stepsArray[currentStep] === 'lo' && (
        <SelectLocation
          next={next}
          prev={prev}
          setFormData={setFormData}
          formData={formData}
          isSmall={true}
        />
      )}
      {stepsArray[currentStep] === 'ad' && (
        <AdditionalInformation
          setFormData={setFormData}
          formData={formData}
          next={next}
          prev={prev}
          isSmall={true}
        />
      )}
      {stepsArray[currentStep] === 'ap' && (
        <Final prev={prev} setFormData={setFormData} formData={formData} isSmall={true} />
      )}
    </Wrapper>
  )
}

export default LeadFormSm;
